import FooterComponent from "./Footer"
import Header from "./Header"
import SkipToContent from "./SkipToContent"
import Container from "@mui/material/Container"
import { styled, useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import { IMegamenuCategory } from "data/contentData/interfaces/IMegamenuCategory"
import { IContainerCard } from "data/contentData/interfaces/mongodb/IContainerCard"
import { ReactNode } from "react"

export default function Layout({
  hideSkipToContent,
  children,
  footer,
  megamenu,
  isMicrosite,
}: {
  hideSkipToContent?: boolean
  children: ReactNode
  footer: IContainerCard[]
  megamenu: IMegamenuCategory[]
  isMicrosite?: boolean
}) {
  const theme = useTheme()
  const smUp = useMediaQuery(theme.breakpoints.up("sm"))

  return (
    <StyledWrapper id="main-content" tabIndex={-1}>
      {!hideSkipToContent && <SkipToContent />}
      <Header megamenu={megamenu} isMicrosite={isMicrosite} />
      <Container
        id="layout-container"
        tabIndex={-1}
        disableGutters={!smUp}
        maxWidth="lg"
        sx={{ position: "relative" }}
      >
        {children}
      </Container>
      <FooterComponent footerData={footer} />
    </StyledWrapper>
  )
}

const StyledWrapper = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  "& #layout-container": {
    scrollMarginTop: "70px",
    [theme.breakpoints.up("md")]: {
      scrollMarginTop: "100px",
    },
  },
}))
